import * as type from "../action-types";
import { IPansPolicy } from '../../models/user';

type load = IPansPolicy;

export const getAcceptedPolicyAction = (payload?: load) => ({
    type: type.GET_ACCEPTED_POLICY_REQUEST,
    payload
});
